import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { DocumentHeadModel } from './types'

interface DocumentHeadRendererProps {
  model: DocumentHeadModel
}

/**
 * The only component that knows Helmet renders the document-head model today.
 * React 19 native head elements can replace this implementation without
 * changing Redux state selection or server middleware.
 */
export default function DocumentHeadRenderer ({ model }: DocumentHeadRendererProps) {
  const {
    htmlAttributes,
    link,
    meta,
    title,
  } = model

  return (
    <Helmet
      htmlAttributes={htmlAttributes}
      link={link}
      meta={meta}
      title={title}
    />
  )
}
